import React, { Component } from 'react';

import { IClubsActions } from '../../../store/player/clubs/actions';
import { IClubsStore } from '../../../store/player/clubs/store';

import { withContext } from '../../../contrib/utils';

interface IProps {
  actions: {
    clubs: IClubsActions;
  };
  clubId: string;
  clubs: IClubsStore;
}

export class ClubPoliciesComponent extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);

    props.actions.clubs.get(Number(props.clubId));
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.clubId !== this.props.clubId) {
      props.actions.clubs.get(Number(props.clubId));
    }
  }

  public render(): JSX.Element {
    const { clubs, clubId } = this.props;
    const club = clubs[Number(clubId)] || {};

    // TODO: REMOVE MOCK
    const policy =
      club.policy ||
      `
      <h2>CLUB TOURNAMENT POLICIES</h2>
      Rancho Park Golf Club (RPGC) members of all skill levels and in good standing with an
      established current index are eligible for competition in all non-major and non-special
      tournament play.

      <h3>PACE OF PLAY POLICY (5/5/2017)</h3>
      RPGC has the following Pace of Play regulation in effect:<br/><br/>

      If your group is more than a hole behind for more than one hole, each member of the group
      will receive a 2-stroke penalty.<br/>Continued infractions will lead to suspension from
      tournament play or, in extreme cases, expulsion from the club - which we have done in the past.
      <br/><br/>
      First offense: 2-stroke penalty.<br/>
      Second offense: 2-stroke penalty and three tournament suspension.<br/>
      Third offense: 2-stroke penalty and one year suspension.
      <br/><br/>
      All penalties are subject to full review by the Pace of Play Committee.
      <br/><br/>
      Remember the #1 rule in Pace of Play:  Keep up with the group in front of you. No excuses.
      The group behind you
      is irrelevant, do not worry about them. Your group must keep the pace with the group
      in front of you. Period.
      <br/><br/>
      Here are some Ready Golf Guidelines to help you keep the pace of play so that everyone has
      a good time on the course.

      <h3>HANDICAPS</h3>
      Please review the Handicap Policy section for details as there have been changes to the
      policy, including the use of a Club Index.

      <h3>LATE WD/NO SHOWS</h3>
      Failure to withdraw within 48 hours of the tournament will result in the forfeiture of your
      signup fee, unless another player from the waiting list takes your spot.
    `;

    return (
      <div className="home club-policies wrapper">
        <div>
          <h2 className="policies-title">POLICIES</h2>
          <div className="policy-body" dangerouslySetInnerHTML={{ __html: policy }} />
        </div>
      </div>
    );
  }
}

const ClubPolicies = withContext(ClubPoliciesComponent, 'clubs');

export { ClubPolicies };
